import { createReducer, on } from "@ngrx/store";

import {
  ActionDetails,
  ActionManagementModel,
  Actions,
  FindingDetails,
  Findings,
} from "../models/action-management.model";
import {
  ADD_ACTIONMANAGEMENT,
  REMOVE_ACTIONMANAGEMENT,
  UPDATE_ACTIONMANAGEMENT,
} from "../actions/action-management.action";

const INITIAL_STATE: ActionManagementModel = {} as ActionManagementModel;

export const ActionManagementReducer = createReducer(
  INITIAL_STATE,
  on(ADD_ACTIONMANAGEMENT, (_, data) => data),

  on(UPDATE_ACTIONMANAGEMENT, (state, { data, entityType }) => {
    let updatedState = { ...state };

    if (entityType === "finding") {
      if (!updatedState.findings) {
        updatedState.findings = {} as Findings;
      }
      updatedState.findings = {
        ...updatedState.findings,
        toDo: updatedState.findings.toDo.map((finding) => {
          if (
            finding.id === (data as FindingDetails).id &&
            finding.assessmentId === (data as FindingDetails).assessmentId
          ) {
            return data as FindingDetails;
          }
          return finding;
        }),
      };
    } else if (entityType === "action") {
      if (!updatedState.actions) {
        updatedState.actions = {} as Actions;
      }

      updatedState.actions = {
        ...updatedState.actions,
        toDo: updatedState.actions.toDo.map((action) => {
          if (
            action.id === (data as ActionDetails).id &&
            action.assessmentId === (data as ActionDetails).assessmentId
          ) {
            return data as ActionDetails;
          }
          return action;
        }),
      };
    }

    return updatedState;
  }),

  on(REMOVE_ACTIONMANAGEMENT, (state, { id, assessmentId, entityType }) => {
    let updatedState = { ...state };

    if (entityType === "finding") {
      if (!updatedState.findings) return state;

      updatedState.findings = {
        ...updatedState.findings,
        toDo: updatedState.findings.toDo.filter(
          (finding) =>
            !(finding.id === id && finding.assessmentId === assessmentId),
        ),
      };
    } else if (entityType === "action") {
      if (!updatedState.actions) return state;

      updatedState.actions = {
        ...updatedState.actions,
        toDo: updatedState.actions.toDo.filter(
          (action) =>
            !(action.id === id && action.assessmentId === assessmentId),
        ),
        followUp: updatedState.actions.followUp.filter(
          (action) =>
            !(action.id === id && action.assessmentId === assessmentId),
        ),
      };
    }

    return updatedState;
  }),
);
